import { rgba } from 'polished';
import { css } from 'styled-components';

export const focusOutline = css`
  outline: 3px solid ${({ theme }) => rgba(theme.palette.primary.main, 0.4)};
  outline-offset: 0;
`;
